import cn from 'classnames';
import type { FC, RefObject } from 'react';
import styles from './userDropdown.module.scss';

type UserDropdownButtonProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  buttonRef: RefObject<HTMLDivElement | null>;
};

const { dropdown, dropdownTitle, icon, chevronDownCustom, chevronUpCustom, sp1, sp2 } = styles;

const UserDropdownButton: FC<UserDropdownButtonProps> = ({ title, isOpen, onToggle, buttonRef }) => {
  return (
    <div role="button" tabIndex={0} ref={buttonRef} className={cn(dropdown)} onClick={onToggle}>
      <span className={dropdownTitle}>
        {title}
        <div
          className={cn(icon, {
            [chevronDownCustom]: isOpen,
            [chevronUpCustom]: !isOpen,
          })}
        >
          <span className={sp1}></span>
          <span className={sp2}></span>
        </div>
      </span>
    </div>
  );
};

export default UserDropdownButton;
